module.exports = __webpack_public_path__ + "static/img/page_11.d32b8c33.png";